module.exports = __webpack_public_path__ + "img/fulweb-coloured.bf403c6e.svg";